/**
 * 任务日志 assignmentCreateNewReportModule
 * 2019-05-13
 * Qian.qianchen
 */
'use strict';
angular.module("assignmentCreateNewReportModule", [])
    .controller("assignmentCreateNewReportCtrl", ["$scope", "$modalInstance", "$q", "$timeout", "assignmentId", "$filter", "trsHttpService", "trsspliceString", "modalDialog", function($scope, $modalInstance, $q, $timeout, assignmentId, $filter, trsHttpService, trsspliceString, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                startTime: new Date(),
                endTime: new Date()
            };
            $scope.data = {
                selectedArray: [],
                selectedReport: [],
                unselectedReport: [],
                channels: ['文字', '图片', '视频', '直播', '可视化', 'H5', 'AR', '节目'],
            };
            initDate();
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            getAssignmentDetail().then(function() {
                return getReportList();
            }).then(function() {
                selectedArrayInit();
            });
        }
        /**
         * [initDate description] 时间初始化
         * @return {[type]} [description]
         */
        function initDate() {
            $scope.status.endTime.setDate($scope.status.startTime.getDate() + 30);
        }
        /**
         * [getAssignmentDetail description] 获取任务详情
         * @return {[type]} [description]
         */
        function getAssignmentDetail() {
            let defer = $q.defer();
            let params = {
                serviceid: "mlf_taskcommand",
                methodname: "getTaskDetail",
                TaskId: assignmentId
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                $scope.data.assignmentDetail = data;
                console.log(data);
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [getReportList description] 获取选题列表
         * @return {[type]} [description]
         */
        function getReportList() {
            let defer = $q.defer();
            let params = {
                serviceid: "mlf_taskcommand",
                methodname: "getNewReports",
                StartTime: $filter("date")($scope.status.startTime, "yyyy-MM-dd"),
                EndTime: $filter("date")($scope.status.endTime, "yyyy-MM-dd")
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                $scope.data.reportList = [];
                data.map(function(group) {
                    $scope.data.reportList = $scope.data.reportList.concat(group.NEWREPORTS.data);
                });
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [selectedArrayInit description] 选中数组初始化
         * @return {[type]} [description]
         */
        function selectedArrayInit() {
            angular.forEach($scope.data.assignmentDetail.NEWREPORTS, function(item, index) {
                if (arrayIndexOf($scope.data.reportList, item, 'NEWREPORTID') > -1) {
                    $scope.data.selectedArray.push($scope.data.reportList[arrayIndexOf($scope.data.reportList, item, 'NEWREPORTID')]);
                }
            });
        }
        /**
         * [arrayIndexOf description] 根据指定属性判断数组中是否含有某元素
         * @param  {[type]} arr      [description] 数组
         * @param  {[type]} item     [description] 元素
         * @param  {[type]} property [description] 属性
         * @return {[type]}          [description]
         */
        function arrayIndexOf(arr, item, property) {
            let index = -1;
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][property] == item[property]) {
                    index = i;
                    return index;
                }
            }
            return index;
        }
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        }
        /**
         * [reportInit description] 选题初始化
         * @param  {[type]} report [description]
         * @return {[type]}        [description]
         */
        $scope.reportInit = function(report) {
            if (report.REPORTTYPE == 1) {
                report.type = '普通';
            } else if (report.REPORTTYPE == 2) {
                report.type = '重要';
            } else if (report.REPORTTYPE == 3) {
                report.type = '紧急';
            } else if (report.REPORTTYPE == 4) {
                report.type = '敏感';
            }
            report.assignmentTime = report.STARTTIME + ' - ' + report.ENDTIME;
            report.executor = trsspliceString.spliceString(report.EXECUTOR, 'USERNAME', '、');
            var metaObj = report.METATYPEINFO[0];
            report.metatypeApp = metaObj.METATYPEBYAPP ? metaObj.METATYPEBYAPP.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : []).join('、') : (metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : []).join('、');
            report.metatypeWeb = metaObj.METATYPEBYWEB ? metaObj.METATYPEBYWEB.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : []).join('、') : (metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : []).join('、');
            report.metatypePaper = metaObj.METATYPEBYPAPER ? metaObj.METATYPEBYPAPER.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : []).join('、') : (metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : []).join('、');
            report.metatypeWeibo = metaObj.METATYPEBYWEIBO ? metaObj.METATYPEBYWEIBO.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYWEIBOOTHER ? [metaObj.METATYPEBYWEIBOOTHER] : []).join('、') : (metaObj.METATYPEBYWEIBOOTHER ? [metaObj.METATYPEBYWEIBOOTHER] : []).join('、');
            report.metatypeWeichat = metaObj.METATYPEBYWECHAT ? metaObj.METATYPEBYWECHAT.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYWECHATOTHER ? [metaObj.METATYPEBYWECHATOTHER] : []).join('、') : (metaObj.METATYPEBYWECHATOTHER ? [metaObj.METATYPEBYWECHATOTHER] : []).join('、');
            report.metatypeTv = metaObj.METATYPEBYTV ? metaObj.METATYPEBYTV.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYTVOTHER ? [metaObj.METATYPEBYTVOTHER] : []).join('、') : (metaObj.METATYPEBYTVOTHER ? [metaObj.METATYPEBYTVOTHER] : []).join('、');
            report.metatypeBroadcast = metaObj.METATYPEBYBROADCAST ? metaObj.METATYPEBYBROADCAST.split(',').map(function(idx) {
                return $scope.data.channels[parseInt(idx) - 1];
            }).concat(metaObj.METATYPEBYBROADCASTOTHER ? [metaObj.METATYPEBYBROADCASTOTHER] : []).join('、') : (metaObj.METATYPEBYBROADCASTOTHER ? [metaObj.METATYPEBYBROADCASTOTHER] : []).join('、');
            report.metatypeOther = metaObj.METATYPEBYOTHER;
        }
        /**
         * [selectToggle description] 选中/取消选中
         * @param  {[type]} report [description] 选题
         * @return {[type]}        [description]
         */
        $scope.selectToggle = function(report) {
            if (arrayIndexOf($scope.data.selectedReport, report, 'NEWREPORTID') < 0) {
                $scope.data.selectedReport.push(report);
            } else {
                $scope.data.selectedReport.splice(arrayIndexOf($scope.data.selectedReport, report, 'NEWREPORTID'), 1);
            }
        }
        /**
         * [transfer description] 移动选题到已选数组
         * @return {[type]} [description]
         */
        $scope.transfer = function() {
            angular.forEach($scope.data.selectedReport, function(item, index) {
                if (arrayIndexOf($scope.data.selectedArray, item, 'NEWREPORTID') < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    // $scope.data.selectedArray.splice(arrayIndexOf($scope.data.selectedArray, item, 'NEWREPORTID'), 1);
                }
            });
            $scope.data.selectedReport = [];
        }
        /**
         * [untransfer description] 从已选数组移除选题
         * @return {[type]} [description]
         */
        $scope.untransfer = function() {
            angular.forEach($scope.data.unselectedReport, function(item, index) {
                $scope.data.selectedArray.splice(arrayIndexOf($scope.data.selectedArray, item, 'NEWREPORTID'), 1);
            });
            $scope.data.unselectedReport = [];
        }
        /**
         * [unselectToggle description] 已选选题列表选中/取消选中
         * @param  {[type]} report [description]
         * @return {[type]}        [description]
         */
        $scope.unselectToggle = function(report) {
            if (arrayIndexOf($scope.data.unselectedReport, report, 'NEWREPORTID') < 0) {
                $scope.data.unselectedReport.push(report);
            } else {
                $scope.data.unselectedReport.splice(arrayIndexOf($scope.data.unselectedReport, report, 'NEWREPORTID'), 1);
            }
        }
        /**
         * [confirm description] 确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            let defer = $q.defer();
            if ($scope.data.selectedArray.length == 0) {
                modalDialog.alertType('请选择选题', '', 'warning', 'confirm');
                defer.reject();
                return;
            } else {
                let params = {
                    serviceid: "mlf_taskcommand",
                    methodname: "saveNewReports",
                    TaskId: assignmentId,
                    NewReportIds: trsspliceString.spliceString($scope.data.selectedArray, 'NEWREPORTID', ',')
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                    modalDialog.alertType('关联选题成功', '', 'success', false, function() {
                        $modalInstance.close();
                    }, 1500);
                    defer.resolve();
                });
            }
            return defer.promise;
        }
        /**
         * [reset description] 重置
         * @return {[type]} [description]
         */
        $scope.reset = function() {
            $scope.data.selectedReport = [];
            $scope.data.unselectedReport = [];
            $scope.data.selectedArray = [];
            selectedArrayInit();
        }
    }]);